var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkeninIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0781 0.828125H1.92188C1.31689 0.828125 0.828125 1.31689 0.828125 1.92188V27.0781C0.828125 27.6831 1.31689 28.1719 1.92188 28.1719H27.0781C27.6831 28.1719 28.1719 27.6831 28.1719 27.0781V1.92188C28.1719 1.31689 27.6831 0.828125 27.0781 0.828125ZM8.93896 24.1284H4.88184V11.0786H8.93896V24.1284ZM6.91211 9.29443C6.44701 9.29443 5.99236 9.15652 5.60565 8.89812C5.21894 8.63973 4.91753 8.27247 4.73955 7.84277C4.56156 7.41308 4.515 6.94026 4.60573 6.4841C4.69647 6.02795 4.92043 5.60894 5.2493 5.28007C5.57818 4.95119 5.99718 4.72723 6.45334 4.63649C6.9095 4.54576 7.38232 4.59233 7.81201 4.77031C8.2417 4.94829 8.60897 5.2497 8.86736 5.63641C9.12576 6.02313 9.26367 6.47778 9.26367 6.94287C9.26025 8.2417 8.20752 9.29443 6.91211 9.29443ZM24.1284 24.1284H20.0747V17.7812C20.0747 16.2671 20.0474 14.3223 17.9658 14.3223C15.8569 14.3223 15.5322 15.9697 15.5322 17.6719V24.1284H11.4819V11.0786H15.3716V12.8628H15.4263C15.9663 11.8374 17.2891 10.7539 19.2646 10.7539C23.373 10.7539 24.1284 13.4575 24.1284 16.9712V24.1284Z",
    fill: "#5CBF14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkeninIcon);
export default __webpack_public_path__ + "static/media/linkenin-icon.18d3f467dd206f51beea10ab00a54429.svg";
export { ForwardRef as ReactComponent };